/**
 * Return value in correct date format
 *
 * @param value
 * @returns {string}
 */
 export default function(value) {
  let result = (value / 1).toFixed(2).replace(".", ",");
  result = "$" + result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return result;
}
